<template>
	<div class="template text" v-show="dataVal.IsShow || dataVal.IsShow == null">
		<div class="panel_wrap">
			<label class="panel_title">{{dataVal.Property.Title[0].Text}}<span v-show="dataVal.Property.Require==1" class="require">*</span>
			</label>
			<div class="input_value">
				<input class="percentage" :change="changeVal(dataVal.Property.Title[0].Text)" v-model="dataVal.Value" type="text" :readOnly="dataVal.Disable" />
				<span class="unit">%</span>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['dataVal'],
		data() {
			return {

			}
		},
		mounted() {

		},
		methods: {
			changeVal(val) {
				var value =this.dataVal.Value;
				if(value == null||value == -1){
					return;
				}
				this.dataVal.Value = (value.toString().match(/^\d{0,9}(\.\d{0,2}){0,1}/g)[0]) || null;
				this.$emit('child-event', this.dataVal.Value, val);
			}
		}
	}
</script>

<style>
	.input_value .percentage{
		display: inline-block;
		color: #868C98;
		padding-left: 10px;
		text-align: right;
		height: 24px;
		line-height: 24px;
		flex: 1;
		box-shadow: none;
		border: none;
		width: calc(100% - 30px);
		margin-right: 7px;
		background: #fff;
	}
</style>
